import { Breakpoint } from '@transferwise/components';
import { default as useClientWidth } from '../useClientWidth';
export function IsMobile() {
    const windowReference = typeof window === 'undefined' ? undefined : window;
    const [clientWidth] = useClientWidth({ ref: windowReference });
    return clientWidth <= Breakpoint.SMALL;
}
